<span
	*ngIf="activeSortPropertyValue"
	class="fs-sx entity_label--color d-block"
>
	{{ activeSortPropertyValue }}
</span>
